export default __webpack_public_path__ + "static/media/01.988873e4.jpg";